module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "unnumbered-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "unnumbered-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise For CJ Lyons’ Thrillers with Heart:")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Everything a great thriller should be—action")]), _vm._v(" packed, authentic, and intense.\" ~#1 New York Times bestselling author Lee Child")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"A compelling new")]), _vm._v(" voice in thriller writing…I love how the characters come alive on every page.\" ~New York Times bestselling author Jeffery Deaver  ")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Top Pick!")]), _vm._v(" A fascinating and intense thriller.\" ~ RT Book Reviews")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"An intense,")]), _vm._v(" emotional thriller…(that) climbs to the edge of intensity.\" ~National Examiner")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"A perfect blend")]), _vm._v(" of romance and suspense. My kind of read.\" ~#1 New York Times Bestselling author Sandra Brown")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Highly engaging characters,")]), _vm._v(" heart-stopping scenes…one great rollercoaster ride that will not be stopping anytime soon.\" ~Bookreporter.com")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Adrenalin pumping.\"")]), _vm._v(" ~The Mystery Gazette")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Riveting.\"")]), _vm._v(" ~Publishers Weekly Beyond Her Book")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Lyons \"is a master within the genre.\"")]), _vm._v(" ~Pittsburgh Magazine")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Will leave")]), _vm._v(" you breathless and begging for more.\" ~Romance Novel TV")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"A great fast-paced read….Not")]), _vm._v(" to be missed.\" ~Book Addict")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Breathtakingly fast-paced.\"")]), _vm._v(" ~Publishers Weekly")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Simply superb…riveting drama…a perfect ten.\"")]), _vm._v(" ~Romance Reviews Today")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Characters with beating")]), _vm._v(" hearts and three dimensions.\" ~Newsday")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"A pulse-pounding adrenalin rush!\"")]), _vm._v(" ~Lisa Gardner")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Packed with adrenalin.\"")]), _vm._v(" ~David Morrell")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"…Harrowing, emotional, action-packed and brilliantly realized.\"")]), _vm._v(" ~Susan Wiggs")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("\"Explodes on the page…I")]), _vm._v(" absolutely could not put it down.\" ~Romance Readers' Connection")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9e528c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-cj-lyons-thrillers-with-heart.vue
// module id = 69
// module chunks = 0